import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from '@material-ui/core'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import { resourceEmprelCorrectiveCols, resourceUserFieldsCols } from '../constants/ResourceCols'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function ResourceEmprelCorrective(props) {
  const { headers, tableRefreshKey } = props

  const [customFieldsDialog, setCustomFieldsDialog] = useState({
    isOpen: false,
    uniqueId: null,
    userFieldClass: null
  })

  const tableDataTransformation = rows => {
    return rows.map(row => ({
      ...row,
      CUSTOM_FIELDS_LINK: (
        <div
          className='editLink'
          onClick={() => setCustomFieldsDialog({
            isOpen: true,
            uniqueId: row.UNIQUEID,
            userFieldClass: row.USERFIELD_CLASS
          })}
        >
          View
        </div>
      )
    }))
  }

  return (
    <div>
      <Dialog
        open={customFieldsDialog.isOpen}
        TransitionComponent={Transition}
        maxWidth='xl'
        scroll='body'
        keepMounted
        onClose={() => setCustomFieldsDialog({ isOpen: false, uniqueId: null, userFieldClass: null })}
      >
        <DialogTitle>Custom Fields</DialogTitle>
        <DialogContent>
          {customFieldsDialog.uniqueId && (
            <DashboardAthenaTable
              {...props}
              isTempTable={false}
              key={customFieldsDialog.uniqueId}
              params={{ uniqueId: customFieldsDialog.uniqueId, userFieldClass: customFieldsDialog.userFieldClass }}
              tableColumns={resourceUserFieldsCols}
              reportName='user_fields'
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => setCustomFieldsDialog({ isOpen: false, uniqueId: null, userFieldClass: null })}
            className='primaryVLButton'
            variant='contained'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <DashboardAthenaTable
        {...props}
        isTempTable={false}
        key={`emprel-corrective-${tableRefreshKey}`}
        params={{ ...headers }}
        tableColumns={resourceEmprelCorrectiveCols}
        reportName='hr_resource_emprel_corrective'
        transform={tableDataTransformation}
      />
    </div>
  )
}
